import React from 'react'

import { usePWAInstall } from '@/b-components/pwa/use-pwa-install'
import {
  SC_StatusWrapper,
  SC_StatusItem,
  SC_StatusLabel,
  SC_StatusValue
} from './styled'

interface T_PWAStatusProps {
  show?: boolean
}

export const PWAStatus: React.FC<T_PWAStatusProps> = ({ show = false }) => {
  const {
    canInstall,
    isInstalled,
    browserType,
    supportsPromptAPI,
    isDismissed
  } = usePWAInstall()

  // Показываем только в режиме разработки или если явно указано
  if (!show && process.env.NODE_ENV !== 'development') {
    return null
  }

  const getInstallStatus = () => {
    if (isInstalled) return { text: 'Установлено', status: 'success' as const }
    if (canInstall) return { text: 'Можно установить', status: 'warning' as const }
    return { text: 'Недоступно', status: 'error' as const }
  }

  const getBrowserName = () => {
    switch (browserType) {
    case 'yandex': return 'Яндекс.Браузер'
    case 'chrome': return 'Chrome'
    case 'safari': return 'Safari'
    case 'firefox': return 'Firefox'
    default: return 'Неизвестный'
    }
  }

  const installStatus = getInstallStatus()


  return (
    <SC_StatusWrapper>
      <SC_StatusItem>
        <SC_StatusLabel>PWA:</SC_StatusLabel>
        <SC_StatusValue $status={installStatus.status}>
          {installStatus.text}
        </SC_StatusValue>
      </SC_StatusItem>

      <SC_StatusItem>
        <SC_StatusLabel>Браузер:</SC_StatusLabel>
        <SC_StatusValue>{getBrowserName()}</SC_StatusValue>
      </SC_StatusItem>

      <SC_StatusItem>
        <SC_StatusLabel>Prompt API:</SC_StatusLabel>
        <SC_StatusValue $status={supportsPromptAPI ? 'success' : 'warning'}>
          {supportsPromptAPI ? 'Доступен' : 'Недоступен'}
        </SC_StatusValue>
      </SC_StatusItem>

      <SC_StatusItem>
        <SC_StatusLabel>Промпт отклонен:</SC_StatusLabel>
        <SC_StatusValue $status={isDismissed ? 'error' : 'success'}>
          {isDismissed ? 'Да' : 'Нет'}
        </SC_StatusValue>
      </SC_StatusItem>

      <SC_StatusItem>
        <SC_StatusLabel>Display mode:</SC_StatusLabel>
        <SC_StatusValue>
          {window.matchMedia('(display-mode: standalone)').matches ? 'Standalone' : 'Browser'}
        </SC_StatusValue>
      </SC_StatusItem>
    </SC_StatusWrapper>
  )
}
